import { FieldNameMap } from '../../../constants/dataSource'
import type { ListGroup } from './types'

export const TYPELISTITEMS: ListGroup = [
    {
        groupName: '基础',
        groupDescription: '数据类型',
        items: [
            { name: 'text', value: FieldNameMap.text },
            { name: 'date', value: FieldNameMap.date },
            { name: 'url', value: FieldNameMap.url },
            { name: 'number', value: FieldNameMap.number },
            { name: 'phoneNumber', value: FieldNameMap.phoneNumber },
            { name: 'email', value: FieldNameMap.email },
            { name: 'select', value: FieldNameMap.select },
            { name: 'file', value: FieldNameMap.file },
            { name: 'video', value: FieldNameMap.video },
            { name: 'person', value: FieldNameMap.person },
            { name: 'checkbox', value: FieldNameMap.checkbox }
        ]
    },
    {
        groupName: '高级',
        items: [
            { name: 'notes', value: '笔记' },
            { name: 'formula', value: FieldNameMap.formula }
        ]
    }
    // {
    //     groupName: '系统',
    //     items: [
    //         { name: 'createdBy', value: FieldNameMap.createdBy },
    //         { name: 'createdTime', value: FieldNameMap.createdTime },
    //         { name: 'updatedBy', value: FieldNameMap.updatedBy },
    //         { name: 'updatedTime', value: FieldNameMap.updatedTime }
    //     ]
    // }
]
